if (!customElements.get('quick-add-modal')) {
  customElements.define('quick-add-modal', class QuickAddModal extends ModalDialog {
    constructor() {
      super();
      this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
    }

    hide(preventFocus = false) {
      const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (cartNotification && cartNotification.setActiveElement) cartNotification.setActiveElement(this.openedBy);
      if (this.modalContent) this.modalContent.innerHTML = '';

      if (preventFocus) this.openedBy = null;
      super.hide();
    }

    show(opener) {
      const productUrl = opener.getAttribute('data-product-url');
      const spinner = opener.querySelector('.loading-overlay__spinner');

      opener.setAttribute('aria-disabled', true);
      opener.classList.add('loading');
      if (spinner) spinner.classList.remove('hidden');

      fetch(productUrl)
        .then((response) => response.text())
        .then((responseText) => {
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');

          /* Fallback: Produktabschnitt nicht gefunden -> normal zur Produktseite */
          if (!this.productElement || !this.modalContent) {
            window.location.href = productUrl;
            return;
          }

          this.preventDuplicatedIDs();
          this.removeDOMElements();
          this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

          if (window.Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }

          if (window.ProductModel) window.ProductModel.loadShopifyXR();

          this.removeGalleryListSemantic();
          this.updateImageSizes();
          this.preventVariantURLSwitching();
          super.show(opener);
        })
        .catch((error) => {
          /* Statt stiller Fehler: auf die Produktseite weiterleiten */
          console.error('Quick add:', error);
          window.location.href = productUrl;
        })
        .finally(() => {
          opener.removeAttribute('aria-disabled');
          opener.classList.remove('loading');
          if (spinner) spinner.classList.add('hidden');
        });
    }

    setInnerHTML(element, html) {
      element.innerHTML = html;

      // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
      element.querySelectorAll('script').forEach(oldScriptTag => {
        const newScriptTag = document.createElement('script');
        Array.from(oldScriptTag.attributes).forEach(attribute => {
          newScriptTag.setAttribute(attribute.name, attribute.value)
        });
        newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
        oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
      });
    }

    /* Null-sicher: Produkte ohne Variantenauswahl-Block haben kein
       variant-radios / variant-selects. Frueher warf das einen Fehler,
       wodurch das Popup gar nicht mehr geoeffnet wurde. */
    preventVariantURLSwitching() {
      if (!this.modalContent) return;
      const variantPicker = this.modalContent.querySelector('variant-radios, variant-selects');
      if (!variantPicker) return;
      variantPicker.setAttribute('data-update-url', 'false');
    }

    removeDOMElements() {
      if (!this.productElement) return;
      const pickupAvailability = this.productElement.querySelector('pickup-availability');
      if (pickupAvailability) pickupAvailability.remove();

      const productModal = this.productElement.querySelector('product-modal');
      if (productModal) productModal.remove();

      /* Sticky-Kaufleiste gehoert nicht ins Popup */
      const stickyForm = this.productElement.querySelector('product-sticky-form');
      if (stickyForm) stickyForm.remove();
    }

    preventDuplicatedIDs() {
      if (!this.productElement) return;
      const sectionId = this.productElement.dataset.section;
      if (!sectionId) return;
      this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${ sectionId }`);
      this.productElement.querySelectorAll('variant-selects, variant-radios').forEach((variantSelect) => {
        variantSelect.dataset.originalSection = sectionId;
      });
    }

    removeGalleryListSemantic() {
      if (!this.modalContent) return;
      const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
      if (!galleryList) return;

      galleryList.setAttribute('role', 'presentation');
      galleryList.querySelectorAll('[id^="Slide-"]').forEach(li => li.setAttribute('role', 'presentation'));
    }

    updateImageSizes() {
      if (!this.modalContent) return;
      const product = this.modalContent.querySelector('.product');
      if (!product) return;
      const desktopColumns = product.classList.contains('product--columns');
      if (!desktopColumns) return;

      const mediaImages = product.querySelectorAll('.product__media img');
      if (!mediaImages.length) return;

      let mediaImageSizes = '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';
      
      if (product.classList.contains('product--medium')) {
        mediaImageSizes = mediaImageSizes.replace('715px', '605px');
      } else if (product.classList.contains('product--small')) {
        mediaImageSizes = mediaImageSizes.replace('715px', '495px');
      }

      mediaImages.forEach(img => img.setAttribute('sizes', mediaImageSizes));
    }
  });
}
